export const __EventCardLang = {
    capacity: 'ظرفیت :',
    cost: 'هزینه',
    free: 'رایگان',
};
